// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24ZT9","newExpiryDate":"styles_newExpiryDate__3m9DY","footer":"styles_footer__ki3u4"};